<template slot-scope="scope">
  <!-- 即将过期发票豆 -->
      <dialogModel
        title="即将过期发票豆"
        :visible.sync="VisibleDueDate"
        @handleClose="handleClose"
        :footer="false"
      >
        <div class="main-body">
          <div>
          <div>
            <el-table :data="tableData">
              <el-table-column
                prop="remain"
                label="未使用发票豆"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="expireTime"
                label="过期时间"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </div>
          <!-- 底部分页 -->
          <div class="paging-box">
            <div class="paging">
              <paging
                :pagingObj="pagingObj"
                @handleCurrentChange="handleCurrentChange"
              ></paging>
            </div>
          </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>
import {
  getCompanyExpiringSoonInvoiceBeans, //获取用户即将过期和已过期的发票豆列表
} from "../../../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
// 引入分页组件
import paging from "../../../.././../../../../components/paging.vue";
export default {
  props: {
    VisibleDueDate: {},
  },

  components: {
    paging,
  },
  data() {
    return {
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      tableData: {},
    };
  },
  watch: {
    VisibleDueDate: {
      handler(newSs, old) {
        if (newSs == true) {
          this.getCompanyExpiringSoonInvoiceBeans(); //获取用户即将过期和已过期的发票豆列表
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    this.getCompanyExpiringSoonInvoiceBeans(); //获取用户即将过期和已过期的发票豆列表
  },
  methods: {
    //获取用户即将过期和已过期的发票豆列表
    getCompanyExpiringSoonInvoiceBeans() {
      var data = {
        data: {},
      };
      API.getCompanyExpiringSoonInvoiceBeans(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
         this.pagingObj.totalDevice = res.data.total
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.getCompanyExpiringSoonInvoiceBeans();
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseDueDate");
    },

  },
};
</script>

<style scoped lang="less">
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.main-body {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  .span-Operation {
    color: #409eff ;
    margin-left: 10px;
  }
  .span-Operation:nth-child(1) {
    margin-left: 0px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
